import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { trackArticleCardClick } from '../../utils/analytics';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function ArticleCard({ article }) {
    const location = useLocation();

    const handleClick = () => {
        const pageName = location.pathname.includes('/home') ? 'Home' :
                         location.pathname.includes('/articles') ? 'All Articles' :
                         location.pathname.includes('/category') ? 'Category' :
                         location.pathname.includes('/article') ? 'Article' : 'Page';
        trackArticleCardClick(article.title, pageName);
    };

    return (
        <div className="article-card card">
            <div className="article-image">
                <Link to={`/article/${article.id}`} onClick={handleClick}>
                    <img src={article.featuredImage} alt={article.title} loading="lazy" />
                </Link>
            </div>
            <div className="article-content">
                <span className="article-category">{article.category}</span>
                <h3 className="article-title">
                    <Link to={`/article/${article.id}`} onClick={handleClick}>{article.title}</Link>
                </h3>
                <p className="article-excerpt">{article.excerpt}</p>
                <div className="article-meta">
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                </div>
            </div>
        </div>
    );
}

export default ArticleCard;
